import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
  category?: string;
}

export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqData: FAQItem[] = [
    {
      category: '⏱️ Tiempos e Implementación',
      question: '¿Cuánto tardaré en tener a mi Agente operando?',
      answer: 'Somos obsesivos con la velocidad. Desde que recibimos tu información (precios, servicios y manuales), la instalación completa se lleva a cabo en una media de 1 a 3 días. Nuestra conexión técnica (vincular la IA con tus sistemas) es aún más rápida: en 24 a 48 horas tu infraestructura suele estar lista para empezar a aprender. No paramos tu negocio ni un solo minuto.'
    },
    {
      question: '¿Es difícil de instalar? ¿Necesito conocimientos técnicos?',
      answer: 'Absolutamente NO. Es un servicio "Llave en Mano". Tú no tocas código ni configuraciones complejas. Nosotros nos encargamos de la ingeniería, la conexión con tu agenda y la carga de datos. Además, te acompañamos en todo momento: desde la primera reunión hasta que ves entrar las primeras citas automáticas en tu Dashboard.'
    },
    {
      category: '🧠 Inteligencia y Personalización',
      question: '¿Mina o Félix son "robots" genéricos o se adaptan a mi marca?',
      answer: 'Son profesionales digitales con una base experta, pero se customizan para ti. Mina ya sabe vender estética y Félix sabe de RRHH, pero nosotros ajustamos sus respuestas con tu tono de voz, tus políticas de cancelación y tus precios. Si prefieres algo 100% único, la opción "Agente a Medida" nos permite crear un clon exacto de tu mejor empleado desde cero.'
    },
    {
      question: '¿Qué pasa si la IA no sabe responder una pregunta difícil?',
      answer: 'La IA nunca inventa. Si se encuentra con una situación clínica compleja o una duda fuera de su base de conocimiento, cualifica la urgencia y transfiere la conversación inmediatamente a tu equipo humano. La diferencia es que tu equipo ya recibe el caso filtrado y con toda la información previa recogida, ahorrando horas de "ping-pong" de mensajes.'
    },
    {
      category: '💰 Inversión y Retorno',
      question: '¿Por qué hay una cuota de mantenimiento mensual?',
      answer: 'Porque no te vendemos un software estático, te alquilamos un "Cerebro Vivo" y una infraestructura de control. Esa cuota cubre: Servidores activos 24/7 para que tu agente no duerma. El coste de procesamiento de la Inteligencia Artificial. Tu acceso al Dashboard del CEO para ver métricas en tiempo real. Soporte técnico continuo: si Facebook o WhatsApp cambian sus reglas, nosotros actualizamos tu agente al instante para que nunca deje de funcionar.'
    },
    {
      question: '¿Realmente voy a recuperar la inversión?',
      answer: 'Hagamos números rápidos. Si Mina recupera un solo cliente perdido al mes (de esos que dejan de venir) o cierra dos citas extra que se hubieran perdido por no responder al teléfono a tiempo, el sistema se ha pagado solo. Además, el ahorro en horas de personal administrativo libera a tu equipo para facturar en tareas de alto valor. No es un gasto, es rentabilidad pura.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-[#0a0f1a]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white italic mb-4">
            FAQ ❓ Preguntas que te estarás haciendo
          </h2>
          <p className="text-gray-400 text-lg">
            Despejamos tus dudas para que solo te preocupes de crecer.
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div key={index}>
              {faq.category && (
                <h3 className="text-xl font-display font-semibold text-white mb-4 mt-8">
                  {faq.category}
                </h3>
              )}
              <div 
                className="bg-[#111827] border border-gray-800 rounded-2xl overflow-hidden transition-all duration-300 hover:border-teal-400/30"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left cursor-pointer transition-colors hover:bg-[#1a2234]"
                >
                  <span className="text-lg font-semibold text-white flex-1">
                    {faq.question}
                  </span>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i 
                      className={`ri-arrow-down-s-line text-2xl text-teal-400 transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </div>
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-8 pb-6 pt-2">
                    <p className="text-gray-400 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};